import { render } from "./AddDownload.vue?vue&type=template&id=4a0b7cbf"
import script from "./AddDownload.vue?vue&type=script&lang=js"
export * from "./AddDownload.vue?vue&type=script&lang=js"

import "./AddDownload.vue?vue&type=style&index=0&id=4a0b7cbf&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__